<template>
  <div style="width: 100%">
    <el-table border size="mini" :data="datas" style="width: 100%">
      <el-table-column
        fixed="left"
        prop="Member.Code"
        label="客户编号"
        width="120"
      >
      </el-table-column>
      <el-table-column prop="Member.Name" fixed="left" label="姓名"  min-width="120">
      </el-table-column>
      <el-table-column prop="Member.Mobile" label="手机号" width="100">
      </el-table-column>
      <el-table-column prop="Member.Sex" label="性别" width="60">
      </el-table-column>
      <el-table-column prop="Member.Birthday" label="年龄" width="60">
        <template slot-scope="scope">
          <span>{{
            format.getAgeByDateString(format.dateFormat(scope.row.Member.Birthday))
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="HipLeftScore" label="左髋疼痛">
      </el-table-column>
      <el-table-column prop="HipRightScore" label="右髋疼痛">
      </el-table-column>
      <el-table-column prop="KneeLeftScore" label="左膝疼痛">
      </el-table-column>
      <el-table-column prop="KneeRightScore" label="右膝疼痛">
      </el-table-column>
      <el-table-column prop="AnkleLeftScore" label="左踝疼痛">
      </el-table-column>
      <el-table-column prop="AnkleRightScore" label="左踝疼痛">
      </el-table-column>
      <el-table-column prop="InsertTime" label="自测时间"  width="120">
        <template slot-scope="scope">
          {{ format.dateTimeFormat(scope.row.InsertTime) }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      background
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :page-sizes="pageSizeList"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      :current-page.sync="pageIndex"
    ></el-pagination>
  </div>
</template>
  <script>
import { getPageList, save, get } from "@/api/check/checkSelf.js";
export default {
  components: {},
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: {
      default: "",
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    filter: {
      handler(val) {
        this.pageIndex = 1;
        this.getData();
      },
    },
  },
  data() {
    return {
      datas: [],
      pageSize: 10,
      pageIndex: 1,
      total: 0,
      pageSizeList: [10, 20, 30, 40, 50],
    };
  },

  methods: {
    getData() {
      this.filter.pageIndex = this.pageIndex;
      this.filter.pageSize = this.pageSize;
      getPageList(this.filter).then((res) => {
        this.datas = res.Items;
        this.total = res.Total || res.Items.length;
      });
    },
    create() {
      this.$refs.vasEditor.handleCreate();
    },
    update(row) {
      let json = JSON.parse(JSON.stringify(row));
      this.$refs.vasEditor.handleEdit(json);
    },
    pageSizeChange(val) {
      var pageSize = `${val}`;
      this.pageIndex = 1;
      this.pageSize = parseInt(pageSize);
      this.$nextTick(() => this.getData());
    },
    pageCurrentChange(val) {
      this.pageIndex = `${val}`;
      this.getData();
    },
  },
  mounted() {},
};
</script>
  <style lang='scss' scoped>
.status {
  align-self: flex-end;
  font-size: 12px;
  font-weight: bold;
  color: #ff862f;
}
.statusdesc {
  align-self: flex-end;
  font-size: 12px;
  color: #797878;
}
</style>